import { BaseApi } from '@/main/baseApi';

import { NAME as FAKTURACNI_PROFIL } from '../constants';
import { DMS_MODULE } from './constants';

const ENDPOINT_NAME = 'PrevzitHodnoty';

export const apiProvider = new BaseApi(DMS_MODULE, FAKTURACNI_PROFIL, ENDPOINT_NAME);
